import { useEffect } from 'react';

// To add a new event, just add one line here. TypeScript infers payloads everywhere.
interface EventMap {
	'scroll-chat-to-position': { scrollTop: number; scrollHeight: number };
	'scroll-chat-to-frame': string;
	'devigner-clear-selection': void;
	'devigner-select-element': string;
}

class EventManager {
	private listeners = new Map<string, Set<Function>>();

	on<K extends keyof EventMap>(event: K, fn: (payload: EventMap[K]) => void): () => void {
		if (!this.listeners.has(event)) this.listeners.set(event, new Set());
		this.listeners.get(event)!.add(fn);
		return () => {
			this.listeners.get(event)?.delete(fn);
		};
	}

	emit<K extends keyof EventMap>(event: K, payload: EventMap[K]): void {
		this.listeners.get(event)?.forEach((fn) => fn(payload));
	}
}

const eventManager = new EventManager();
export default eventManager;

export function useEventListener<K extends keyof EventMap>(
	event: K,
	fn: (payload: EventMap[K]) => void
) {
	useEffect(() => eventManager.on(event, fn), [event, fn]);
}
